// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"addForm_AddNewGoalPop__sVGdE","modalBody":"addForm_modalBody__AWL3j","formControl":"addForm_formControl__n5WBA","add":"addForm_add__UDQ+l"};